import { Controller } from 'stimulus';
import 'readmore-js';

class ReadMoreController extends Controller {
  connect() {
    $(this.element).readmore({
      collapsedHeight: 90,
      heightMargin: 32,
      moreLink: `
        <button type="button" class="btn btn--primary">
          + ${this.data.get('collapsed-text')}
        </button>
      `,
      lessLink: `
        <button type="button" class="btn btn--primary">
          - ${this.data.get('expanded-text')}
        </button>
      `,
    });
  }

  static getIcon(name) {
    return `<svg class="icon ${name} icon--lg mr-2 color-primary" aria-hidden="true"><use xlink:href="#icon-${name}"></use></svg>`;
  }
}

ReadMoreController.targets = [
  //
];

export default ReadMoreController;
